<ng-container *ngIf="mode === 'single'; else rangeHeader">
  <app-header-component
    class="box-shadow-bottom"
    [headerData]="currentHeaderData"
    (closeModal)="closeModal()"
  ></app-header-component>
</ng-container>

<ng-template #rangeHeader>
  <ion-header class="ion-no-border calendar-range-header">
    <ion-toolbar class="title-toolbar no-safe-area-top">
      <div class="modal-title-row">
        <ion-text class="fs-5 font600 title-text-color">
          {{ "shared.modals.calendar.select_prefix" | translate }}
          <span class="green-text-color">
            {{
              (activeField === "start" ? rangeStartKey : rangeEndKey)
                | translate
            }}
          </span>
          {{ "shared.modals.calendar.date_suffix" | translate }}
        </ion-text>
        <ion-buttons slot="end">
          <ion-button
            class="close-btn"
            fill="clear"
            (click)="closeModal()"
            aria-label="close"
          >
            <ion-icon slot="icon-only" name="close-outline"></ion-icon>
          </ion-button>
        </ion-buttons>
      </div>
    </ion-toolbar>
  </ion-header>
</ng-template>

<ion-content class="calendar-content">
  <div class="weekday-row ion-padding">
    <div class="weekday-cell fs-3 font600" *ngFor="let wd of weekDays">
      {{ "shared.modals.calendar.weekdays." + wd | translate }}
    </div>
  </div>

  <div class="months-container">
    <div
        class="month-block"
        *ngFor="let month of months; trackBy: trackMonth"
        [attr.id]="'month-' + month.year + '-' + month.month"
      >
      <div class="month-label-wrapper">
        <span class="month-label font600 card-primary-text-color">{{ month.label }}</span>
      </div>

      <div class="weeks-grid">
        <div
          class="week-row"
          *ngFor="let week of month.weeks; trackBy: trackWeek"
        >
          <div
            class="day-cell"
            *ngFor="let day of week; trackBy: trackDay"
            [class.day-empty]="day.classes.empty"
            [class.day-disabled]="day.classes.disabled && !day.classes.empty"
            [class.day-selected]="day.classes.selected"
            [class.day-today]="day.classes.today"
            [class.day-in-range]="day.classes.inRange"
            [class.day-range-start]="day.classes.rangeStart"
            [class.day-range-end]="day.classes.rangeEnd"
            (click)="!day.classes.disabled && selectDay(day)"
          >
            <ng-container *ngIf="day.day">
              <span class="day-number card-primary-text-color">{{ day.day }}</span>
              <span class="day-price" *ngIf="day.price != null">
                {{ currencySymbol }} {{ day.price | number : "1.0-0" }}
              </span>
              <div class="day-badges" *ngIf="day.badges?.length">
                <span
                  class="badge-dot"
                  *ngFor="let badge of day.badges"
                  [style.background]="badge.color"
                  [style.color]="badge.textColor || '#fff'"
                >
                  {{ badge.label }}
                </span>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</ion-content>

<ion-footer class="bg-white calendar-footer">
  <ion-toolbar class="ion-no-padding ion-no-margin ion-no-border">
    <ng-container *ngIf="mode === 'range'">
      <ion-card class="no-shadow border-r10 range-summary-card">
        <div
          class="range-section range-section-start"
          [class.active]="activeField === 'start'"
          [class.filled]="!!internalStart"
          role="button"
          tabindex="0"
          [attr.aria-label]="rangeStartLabelKey | translate"
          (click)="onStartSummaryTap()"
          (keydown.enter)="onStartSummaryTap()"
          (keydown.space)="onStartSummaryTap(); $event.preventDefault()"
        >
          <span class="field-label-text fs-2 font400">
            {{ rangeStartLabelKey | translate }}
          </span>
          <span class="field-value fs-4 font600 card-primary-text-color">
            {{
              internalStart
                ? formatLong(internalStart)
                : ("shared.modals.calendar.empty_value" | translate)
            }}
          </span>
        </div>

        <div
          class="range-section range-section-end"
          [class.active]="activeField === 'end'"
          [class.filled]="!!internalEnd"
          role="button"
          tabindex="0"
          [attr.aria-label]="
            internalEnd
              ? (rangeEndLabelKey | translate)
              : (addRangeEndTitleKey | translate)
          "
          (click)="internalEnd ? onEndSummaryTap() : onAddEndTap()"
          (keydown.enter)="
            internalEnd ? onEndSummaryTap() : onAddEndTap()
          "
          (keydown.space)="
            internalEnd ? onEndSummaryTap() : onAddEndTap();
            $event.preventDefault()
          "
        >
          <ng-container
            *ngIf="internalEnd || activeField === 'end' || requireRangeEnd; else addEndContent"
          >
            <span class="field-label-text fs-2 font400 card-secondary-text-color">
              {{ rangeEndLabelKey | translate }}
            </span>
            <span class="field-value fs-4 font600 card-primary-text-color">
              {{
                internalEnd
                  ? formatLong(internalEnd)
                  : ("shared.modals.calendar.empty_value" | translate)
              }}
            </span>
          </ng-container>
          <ng-template #addEndContent>
            <div class="add-end-box">
              <span class="fs-2 font400 title-text-color add-end-box-title">{{
                addRangeEndTitleKey | translate
              }}</span>
              <span class="fs-2 font600 subtitle-text-color mart4 add-end-box-subtitle">{{
                addRangeEndSubtitleKey | translate
              }}</span>
            </div>
          </ng-template>
        </div>
      </ion-card>
    </ng-container>

    <ng-container *ngIf="mode === 'range'; else singleConfirmBtn">
      <ion-button
        class="primary-btn confirm-btn font700 range-confirm-btn"
        [disabled]="!canConfirm"
        (click)="confirm()"
        expand="block"
        mode="ios"
      >
        {{ "shared.modals.calendar.done" | translate }}
      </ion-button>
    </ng-container>
    <ng-template #singleConfirmBtn>
      <ion-button
        class="primary-btn confirm-btn font700 ion-margin"
        [disabled]="!canConfirm"
        (click)="confirm()"
        expand="block"
      >
        {{ confirmLabel || ("shared.modals.calendar.confirm" | translate) }}
      </ion-button>
    </ng-template>
  </ion-toolbar>
</ion-footer>
